import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LoadingService} from './loading.service';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient,
              private loadingService: LoadingService) {
  }

  async getBlob(url: string, hideLoading?: boolean): Promise<Blob | undefined> {
    if (hideLoading) {
      return await this.http.get(url, {responseType: 'blob'}).toPromise();
    }
    try {
      this.loadingService.show();
      return await this.http.get(url, {responseType: 'blob'}).toPromise();
    } finally {
      this.loadingService.hide();
    }
  }

  // 本当はサーバ側でContent-Encodingを指定すべきだったが、すでに大分データが登録されてしまっているのでクライアント側で回答する
  async getGzip<T>(url: string, hideLoading?: boolean): Promise<T | null> {
    const blob = await this.getBlob(url, hideLoading);
    if (blob) {
      const decompressedStream = blob.stream().pipeThrough(
        new DecompressionStream('gzip'),
      );
      return JSON.parse(await new Response(decompressedStream).text()) as T;
    }
    return null;
  }

  async put(url: string, parameter: object, hideLoading?: boolean): Promise<any> {
    if (hideLoading) {
      return await this.http.put(url, parameter).toPromise();
    }
    try {
      this.loadingService.show();
      return await this.http.put(url, parameter).toPromise();
    } finally {
      this.loadingService.hide();
    }
  }
}
